import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class CopilotCommandResponse extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "copilotCommandResponse";
    }

    public async receive(payload: CometOperatorApplication.CopilotCommandResponseCometMessageOpenApiModel) {
        if (payload.tokenId == OperatorAccountStore.tokenId.value) {
            OperatorApplicationEventManager.emit(payload.commandId, payload.response);
        }
    }

}